"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Paging;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _queryString = require("query-string");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _FirstPageIcon, _ChevronLeftIcon, _ChevronRightIcon, _LastPageIcon;
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    menuItem: {
      '&.MuiMenuItem-root.Mui-selected': {
        backgroundColor: theme.isDark() ? theme.palette.background.paper : theme.palette.common.white
      },
      '&.MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },
    pagingSelect: {
      marginLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }
  };
});
function Paging(_ref) {
  var getFirstPageLink = _ref.getFirstPageLink,
    getItemsPerPageLink = _ref.getItemsPerPageLink,
    getLastPageLink = _ref.getLastPageLink,
    getNextPageLink = _ref.getNextPageLink,
    getPrevPageLink = _ref.getPrevPageLink,
    hasNextPage = _ref.hasNextPage,
    id = _ref.id,
    itemsOnPage = _ref.itemsOnPage,
    _ref$itemsPerPage = _ref.itemsPerPage,
    itemsPerPage = _ref$itemsPerPage === void 0 ? 20 : _ref$itemsPerPage,
    itemsPerPageKey = _ref.itemsPerPageKey,
    _ref$itemsPerPageOpti = _ref.itemsPerPageOptions,
    itemsPerPageOptions = _ref$itemsPerPageOpti === void 0 ? [20, 50, 100] : _ref$itemsPerPageOpti,
    _ref$noTotal = _ref.noTotal,
    noTotal = _ref$noTotal === void 0 ? false : _ref$noTotal,
    page = _ref.page,
    showingResultsKey = _ref.showingResultsKey,
    _ref$showResultsPerPa = _ref.showResultsPerPage,
    showResultsPerPage = _ref$showResultsPerPa === void 0 ? true : _ref$showResultsPerPa,
    totalItems = _ref.totalItems;
  var classes = useStyles();
  var history = (0, _reactRouterDom.useHistory)();
  var search = (0, _queryString.parse)(history.location.search);
  var offset = (page - 1) * itemsPerPage || 0;
  var handleFirstPageLink = function handleFirstPageLink() {
    return {
      search: (0, _queryString.stringify)((0, _extends2.default)({}, search, {
        page: 1
      }))
    };
  };
  var handleBackPageLink = function handleBackPageLink() {
    return {
      search: (0, _queryString.stringify)((0, _extends2.default)({}, search, {
        page: page - 1
      }))
    };
  };
  var handleNextPageLink = function handleNextPageLink() {
    return {
      search: (0, _queryString.stringify)((0, _extends2.default)({}, search, {
        page: page + 1
      }))
    };
  };
  var handleLastPageLink = function handleLastPageLink() {
    return {
      search: (0, _queryString.stringify)((0, _extends2.default)({}, search, {
        page: Math.max(1, Math.ceil(totalItems / itemsPerPage))
      }))
    };
  };
  var handleItemsPerPageLink = function handleItemsPerPageLink(value) {
    return {
      search: (0, _queryString.stringify)((0, _extends2.default)({}, search, {
        limit: value,
        page: 1
      }))
    };
  };
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true,
    direction: "row",
    id: id,
    justifyContent: "space-between",
    spacing: 1
  }, showResultsPerPage && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "".concat(id, "ItemsPerPage"),
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: itemsPerPageKey
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Select, {
    className: classes.pagingSelect,
    id: "".concat(id, "SelectContainer"),
    SelectDisplayProps: {
      id: "".concat(id, "SelectButton")
    },
    value: itemsPerPage,
    variant: "outlined"
  }, itemsPerPageOptions.map(function (value, i) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: value,
      className: classes.menuItem,
      component: _reactRouterDom.Link,
      id: "".concat(id, "Select").concat(i, "Link"),
      to: getItemsPerPageLink ? getItemsPerPageLink(value) : handleItemsPerPageLink(value),
      value: value
    }, value);
  }))))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true
  }, !!(totalItems || itemsOnPage) && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    id: "".concat(id, "ResultsContainer"),
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "".concat(id, "Results"),
    variant: "body2"
  }, noTotal ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: showingResultsKey,
    values: {
      showEnd: offset + itemsOnPage,
      showStart: offset + 1
    }
  }) : /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: showingResultsKey,
    values: {
      count: totalItems,
      showEnd: Math.min(totalItems, offset + itemsPerPage),
      showStart: offset + 1
    }
  }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    component: _reactRouterDom.Link,
    disabled: page === 1,
    id: "".concat(id, "FirstPageButton"),
    size: "large",
    to: getFirstPageLink ? getFirstPageLink() : handleFirstPageLink()
  }, _FirstPageIcon || (_FirstPageIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.FirstPage, null))), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    component: _reactRouterDom.Link,
    disabled: page - 1 < 1,
    id: "".concat(id, "PrevPageButton"),
    size: "large",
    to: getPrevPageLink ? getPrevPageLink(page) : handleBackPageLink()
  }, _ChevronLeftIcon || (_ChevronLeftIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.ChevronLeft, null))), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    component: _reactRouterDom.Link,
    disabled: noTotal ? !hasNextPage : page >= totalItems / itemsPerPage,
    id: "".concat(id, "NextPageButton"),
    size: "large",
    to: getNextPageLink ? getNextPageLink(page) : handleNextPageLink()
  }, _ChevronRightIcon || (_ChevronRightIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.ChevronRight, null))), !noTotal && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    component: _reactRouterDom.Link,
    disabled: page >= Math.ceil(totalItems / itemsPerPage),
    id: "".concat(id, "LastPageButton"),
    size: "large",
    to: getLastPageLink ? getLastPageLink() : handleLastPageLink()
  }, _LastPageIcon || (_LastPageIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.LastPage, null)))))));
}